import {
  Breadcrumbs,
  Container,
  Divider,
  Grid,
  ThemeProvider,
  Typography,
  createTheme,
  makeStyles,
} from "@material-ui/core";
import { useLocation } from "react-router";
import { ButtonGroupTop } from "../../../components/atoms/Button";
import { Page } from "components";
import ComponentReportProcess from "./ComponentReportProcess";
import ComponentReportProcessMonitoring from "./ComponentReportProcessMonitoring";
import ComponentReportProcessDownload from "./ComponentReportProcessDownload";
import ComponentPotentialClaimMatching from "./ComponentPotentialClaimMatching";

const theme = createTheme({
  typography: {
    fontFamily: ["Inter"].join(","),
  },
});

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  divider: {
    margin: theme.spacing(2, 0),
    borderTop: "1px solid #e1e1e1",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  pagination: {
    "& .Mui-selected": {
      backgroundColor: "black",
      color: "white",
    },
  },
  pageSize: {
    height: "30px",
    borderRadius: "6px",
    border: "1px solid #D1D5DC",
    paddingLeft: "5px",
    paddingRight: "5px",
    marginTop: "5px",
  },
  paginationText: {
    fontSize: "14px",
    fontWeight: "normal",
    fontStyle: "normal",
    color: "#687083",
  },
  breadcrumbs: {
    fontSize: "14px",
    fontWeight: 400,
    fontStyle: "regular",
    color: "#111827",
  },
  title: {
    fontSize: "24px",
    fontWeight: "700",
    lineHeight: "32px",
  },
  breadCrumbsActive: {
    fontSize: "14px",
    fontWeight: 400,
    fontStyle: "regular",
    color: "#687083",
  },
  placeholder: {
    "&::placeholder": {
      color: "#9AA2B1",
    },
  },
  subTitle: {
    fontSize: "18px",
    fontWeight: 700,
    color: " #111827",
  },
  headText: {
    fontSize: "12px",
    color: "#687083",
    fontWeight: "bold",
  },
  content: {
    paddingTop: 15,
    padding: "15px 1px",
  },
}));
const listMenu = [
  {
    id: 0,
    title: "DSRF Download",
    link: "/admin/dsrf/download-dsrf",
  },
  {
    id: 1,
    title: "DSRF Report Process",
    link: "/admin/dsrf/report-process",
  },
  {
    id: 2,
    title: "DSRF Monitoring",
    link: "/admin/dsrf/process-monitoring",
  },
  {
    id: 3,
    title: "DSRF Matching 2",
    link: "/admin/dsrf/dsrf-matching",
  },
];

function ReportProcess() {
  const classes = useStyles();
  const location = useLocation();
  const activeTab = listMenu.findIndex(
    item =>
      item.link === location.pathname ||
      (item.id === 1 && location.pathname === "/admin/dsrf/process-dsrf") ||
      (item.id === 3 &&
        (location.pathname === "/admin/dsrf/dsrf-matching" ||
          location.pathname === "/admin/dsrf/dsrf-matching-2" ||
          location.pathname === "/admin/dsrf/matching-2" ||
          location.pathname === "/admin/dsrf/potential-claim" ||
          location.pathname === "/admin/dsrf/potential-claim-matching" ||
          location.pathname === "/admin/publisher/potential-claim"))
  );

  const selectedPage = activeTab >= 0 ? activeTab : 0;
  return (
    <Page className={classes.root} title="DSRF Process">
      <Container maxWidth={false}>
        <Grid
          alignItems="flex-end"
          container
          justifyContent="space-between"
          spacing={3}
        >
          <Grid item>
            <ThemeProvider theme={theme}>
              <Typography className={classes.title}>
                DSRF Process
              </Typography>
            </ThemeProvider>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="breadcrumb">
              <Typography className={classes.breadcrumbs}>Home</Typography>
              <Typography className={classes.breadCrumbsActive}>
                DSP Usage Process
              </Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>
        <Divider className={classes.divider} />
        <ButtonGroupTop items={listMenu} selectedPage={selectedPage} />
        <Grid container className={classes.content}>
          <Grid item xs={12}>
            {selectedPage === 0 ? (
              <ComponentReportProcessDownload />
            ) : selectedPage === 1 ? (
              <ComponentReportProcess />
            ) : selectedPage === 2 ? (
              <ComponentReportProcessMonitoring />
            ) : (
              <ComponentPotentialClaimMatching />
            )}
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
export default ReportProcess;
